import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import ElementUI from 'element-ui'
import axios from 'axios'
import Decimal from "decimal.js"
import Nprogress from 'nprogress' //进度条
import 'nprogress/nprogress.css'
import moment from 'moment'
import echarts from "echarts";

import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
// 导入字体图标样式
import './assets/fonts/iconfont.css'
import './assets/fontss/iconfont.css'
import './assets/fontssss/iconfont.css'
// import './assets/fontsssss/iconfont.css'
import './assets/fonticon/iconfont.css'

import './assets/fontsssss/iconfont.js'
import './assets/fonticon/iconfont.js'


import {Button,Form,FormItem,Input,Message,
Container,Header,Aside,Main,Menu,Submenu,MenuItem,
Breadcrumb,BreadcrumbItem,Card,Row,Col,Table,TableColumn,
Switch,Tooltip,Pagination,Dialog,Notification,Checkbox,
InputNumber,Avatar,CheckboxGroup,Popover,Tag,Popconfirm,
Dropdown,DropdownMenu,DropdownItem,Tabs,TabPane,Loading,
Select,Option,Badge,DatePicker,Upload,Link, Radio, RadioGroup, Alert} from 'element-ui'



import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// # 1. copy-webpack-plugin@11.0.0

axios.defaults.baseURL = 'https://developer.7ccccccc.com/api/'

// axios.defaults.baseURL = 'http://localhost:5000/api/'


//axios.defaults.withCredentials = true;//允许跨域携带cookie信息

axios.interceptors.request.use(config => {
  Nprogress.start()
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})

axios.interceptors.response.use(config => {
  Nprogress.done()
  console.log("---config",config.data);

  // if(config.data.code === -6){
  //   vm.$router.push('/recharge')
  //   alert('套餐已过期，请充值\n充值成功后，请在页面右上角账号处进行退出登录\n重新登录即可\n如有问题请加管理QQ：58346871')
  // }

  // if(config.data.code === -2 || config.data.code === -3 || config.data.code === -5){
  if (config.data && config.data.meta) {
    if(config.data.meta.status === -2 || config.data.meta.status === -3 || config.data.meta.status === -5){
      window.sessionStorage.removeItem("token");
      window.localStorage.removeItem("token");
      vm.$notify.error({title: '错误', message:config.data.meta.msg});
      vm.$router.push('/login')
    }
  }
  // else{
  //   console.log(",,,,,,,,,,,,,,,",config.meta.status);
  // }
    
  // }

  if(config.meta){
  //   console.log("进来没");
    if(config.meta.status && config.meta.status === -6){
      vm.$router.push('/recharge')
      alert('套餐已过期，请充值\n充值成功后，请在页面右上角账号处进行退出登录\n重新登录即可\n如有问题请加管理QQ：58346871')
    }
  }

  return config
})

Vue.prototype.$moment = moment;
Vue.prototype.$download = "https://download.7ccccccc.com:56666"
// Vue.prototype.$download = "http://localhost:5001"
Vue.prototype.$bus = new Vue()//事件总线
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$Decimal = Decimal
//Vue.use(ElementUI)
Vue.use(Link)
Vue.use(Upload)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.prototype.$message = Message
Vue.prototype.$echarts = echarts
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.prototype.$notify = Notification
Vue.use(Checkbox)
Vue.use(InputNumber)
Vue.use(Avatar)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(Tag)
Vue.use(Popconfirm)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tabs)
Vue.use(TabPane)
//Vue.prototype.$Loading = Loading
Vue.use(Loading)
Vue.use(Select)
Vue.use(Option)
Vue.use(Badge)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Alert)
var vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

